import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const LabDataModule = lazy(loadModule);

export default LabDataModule;
